import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.2 7.99999C11.2 8.46665 11.0201 8.93332 10.6667 9.28665L6.32005 13.6333C6.12672 13.8267 5.80672 13.8267 5.61338 13.6333C5.42005 13.44 5.42005 13.12 5.61338 12.9267L9.96005 8.57999C10.2801 8.25999 10.2801 7.73999 9.96005 7.41999L5.61338 3.07332C5.42005 2.87999 5.42005 2.55999 5.61338 2.36665C5.80672 2.17332 6.12672 2.17332 6.32005 2.36665L10.6667 6.71332C11.0201 7.06665 11.2 7.53332 11.2 7.99999Z",
      fill: "var(--text-secondary)"
    }, null, -1)
  ])))
}
export default { render: render }